import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { GetStatusCategoriesUseCase } from '@features/statuses';

export const getStatusesResolver: ResolveFn<void> = () => {
  const getCategories = inject(GetStatusCategoriesUseCase);

  // Pre-load categories for the status flyout (non-blocking)
  getCategories.execute().subscribe();
};
